import { CommunicationPreferenceUpdateInput } from '@occc/graphql';
import { useCommunicationPreferenceUpdateMutation } from '@occc-app/dataAccessLayer/customer/mutations';
import { useGetCommunicationPreferencesForAllSubBrandsQuery } from '@occc-app/dataAccessLayer/customer/queries';
import { snackbar } from '@occc-app/design-system';
import { parsePhoneNumber } from '@occc/utils-phone-number';

import { CommunicationPreference } from './communication-preferences';
import { communicationPreferencesUpdateSuccess } from './communication-preferences.messages';

import { errorMessage } from '../../copies';

type CommunicationPreferencesControllerProps = {
  customerUuid: string;
  phoneNumber?: string | null;
  isUserPermittedToEdit: boolean;
};

export const CommunicationPreferencesController = ({
  customerUuid,
  phoneNumber,
  isUserPermittedToEdit,
}: CommunicationPreferencesControllerProps) => {
  const membershipPhoneNumber = phoneNumber ? parsePhoneNumber(phoneNumber) : undefined;
  const isUSPhoneNumber = membershipPhoneNumber?.country === 'US';

  const { data } = useGetCommunicationPreferencesForAllSubBrandsQuery({
    variables: {
      customerUuid,
    },
  });
  const communicationPreferences = data?.getCommunicationPreferencesForAllSubBrands || [];

  const [updateCustomerCommunicationPreference, { loading: updateInProgress }] =
    useCommunicationPreferenceUpdateMutation({
      refetchQueries: ['getCommunicationPreferencesForAllSubBrands'],
      onCompleted: () => snackbar.success(communicationPreferencesUpdateSuccess),
      onError: () => snackbar.error(errorMessage),
    });

  const updateCommunicationPreference = (
    input: Omit<CommunicationPreferenceUpdateInput, 'customerUuid'>,
  ) =>
    updateCustomerCommunicationPreference({
      variables: {
        input: {
          customerUuid,
          ...input,
        },
      },
    });

  if (!communicationPreferences?.length) {
    return null;
  }

  return (
    <CommunicationPreference
      communicationPreferences={communicationPreferences}
      updateCommunicationPreference={updateCommunicationPreference}
      updateInProgress={updateInProgress}
      isUSPhoneNumber={isUSPhoneNumber}
      isUserPermittedToEdit={isUserPermittedToEdit}
    />
  );
};
